/* eslint-disable no-console */
import _ from 'lodash';
import { useEffect, useState } from 'react';

import { usePlmPath } from '../utilities/PgmUtilities';

export function paramToQuerystring(queryParams = {}) {
    const stringSeparator = '&';
    if (_.isEmpty(queryParams)) {
        return '';
    }
    return `?${_.keys(queryParams)
        .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`)
        .join(stringSeparator)}`;
}

export async function asyncFetch(uri, queryParams = {}) {
    const url = `${uri}${paramToQuerystring(queryParams)}`;

    // eslint-disable-next-line react-portal/no-global-fetch
    const response = await fetch(url);
    if (!response.ok) throw new Error(`Unable to fetch error: ${response.statusText} url: ${url}`);
    return response.json();
}

export default function useFetch(url) {
    const path = usePlmPath(url);
    const [data, setData] = useState();
    useEffect(() => {
        if (path.includes('undefined')) {
            setData(undefined);
            return;
        }

        // eslint-disable-next-line react-portal/no-global-fetch
        fetch(path)
            .then((res) => {
                if (!res.ok) {
                    console.log(`ERROR FETCHING: StatusText ${res.statusText}, url: ${path}`);
                    return undefined;
                }
                return res.json();
            })
            .then((json) => setData(json));
    }, [path]);
    return data;
}
